import React, { useCallback } from 'react';

import Button from '@ott/button';
import MoneyIcon from '@ott/icon-money';
import { l10n } from '@ott/l10n';
import Modal, { CONTENT_SIZE } from '@ott/modal';
import KM from '@ott/utility-km';

import styles from './TransferPromoModal.scss';

type Props = {
  isOpen?: boolean;
  onAction: VoidFunction;
  onClose: VoidFunction;
};

const TransferPromoModal = ({ isOpen = true, onClose, onAction }: Props) => {
  const handleActionButtonClick = useCallback(() => {
    KM('Virtual_Card_Transfer_Upgrade');
    onAction();
  }, [onAction]);

  return (
    <Modal
      isOpen={isOpen}
      contentOptions={{
        size: CONTENT_SIZE.SMALL,
        icon: <MoneyIcon />,
        title: l10n('virtualCard.transferPromo.title'),
        footerContentNode: (
          <Button
            purpose="defaultPurpose"
            withFullWidth={true}
            onClick={handleActionButtonClick}
            specificLocators="virtual-card-transfer-promo-modal-action-button"
          >
            {l10n('virtualCard.transferPromo.action')}
          </Button>
        ),
      }}
      onClose={onClose}
      specificLocators="virtual-card-transfer-promo-modal"
    >
      <div className={styles.description}>{l10n('virtualCard.transferPromo.description')}</div>
    </Modal>
  );
};

export default React.memo(TransferPromoModal);
